import React, { Component } from 'react';
import Modal from 'react-modal'

import MailchimpSubscribe from "react-mailchimp-subscribe"
import { Formik } from 'formik';
import { Button, Col, Form, FormFeedback, FormGroup, Label, Input, Card, CardHeader, CardBody, Row, InputGroup} from 'reactstrap';
import * as Yup from 'yup';

const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)',
    width                 : '550px',
    height                 : '180px',
    border: 0,
    padding: 33,
    borderRadius: 20
  },
  overlay: {
    backgroundColor: 'rgba(0,0,0,0.4)'
  }
};

class MailchimpForm extends Component {
  ValidationSchema = Yup.object().shape({
    EMAIL: Yup.string()
      .email('Invalid email')
      .required('Required'),
  });
  constructor(props){
    super(props)
    this.state = {
      subscribe:'',
      errorMsg:''
    }
   // this.touchAll = this.touchAll.bind(this)
  }
  onSubmit = (values, { setSubmitting, setErrors }) => {
    this.props.onSubmitted(values)
    //this.setState({subscribe:'Subscribing now...'})
  }
  componentWillReceiveProps(nextProps){
    this.setState({subscribe: nextProps.sendingState, errorMsg: nextProps.errorMsg})
  }
  render (){

    return (
  <div>
    <Formik
      initialValues={{
        EMAIL: '',
      }}
      validationSchema={this.ValidationSchema}
      onSubmit={this.onSubmit}
    >
      {({ errors, touched, values, handleChange, handleSubmit, isValid, setTouched}) => (
          <Form onSubmit={handleSubmit} noValidate name='subscribeForm'>
            <FormGroup style = {{width: 300}}>
            <InputGroup>
                <Input type="email"
                        name="EMAIL"
                        id="EMAIL"
                        placeholder="Email"
                        // valid={!errors.email}
                        invalid={touched.EMAIL && !!errors.EMAIL}
                        autoFocus={true}
                        onChange={handleChange}
                        required
                        value={values.EMAIL} />
                <div className="input-group-append">
                  <span className="input-group-text"><i className="fa fa-envelope"></i></span>
                </div>
                <FormFeedback>{errors.EMAIL}</FormFeedback>
              </InputGroup>
              </FormGroup>

             {/* { (this.state.subscribe === 'error')?<div style={{ color: "red" }} dangerouslySetInnerHTML={{__html: this.state.errorMsg}}/>
             :<div style={{color:"#4dbd74"}}>{this.state.errorMsg}</div> } */}

            <FormGroup style ={{width: 100, float:'right', marginTop:-51, marginRight:35}}>
              <Button 
                // onClick={() => this.touchAll(setTouched, errors)} 
                type="submit" color="success" className="mr-1" style={{float:"right"}}>Subscribe</Button>
            </FormGroup>                       
          </Form>
      )}
    </Formik>
  </div>
);
}
}

//Modal.setAppElement('#root')

class MailchimpModal extends Component {
  constructor() {
    super();
 
    this.state = {
      modalIsOpen: false
    };
  }

  openModal = () => {
    this.setState({modalIsOpen: true});
  }
 
  afterOpenModal = () => {
    // references are now sync'd and can be accessed.
    //this.subtitle.style.color = '#f00';
  }

  componentWillReceiveProps(nextProps) {
    this.setState({modalIsOpen: nextProps.modalIsOpen})
  }
  closeModal = () => {
    this.props.closeModal();
    this.setState({modalIsOpen: false});
  }
  render() {
    return (
      <React.Fragment>
        <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModal}
          style={customStyles}
          contentLabel="Example Modal"
          shouldFocusAfterRender={true}
          shouldCloseOnOverlayClick={true}
          ariaHideApp={true}
        >
          <div style={{backgroundColor:"white", fontSize:15, textAlign:"center"}}>
          <h5>Get Alerts when the Growjo 10,000 is updated</h5>
          <MailchimpSubscribe
            url={"https://growjo.us20.list-manage.com/subscribe/post?u=3d5b446d5a91119be9bb3d330&id=82ceabf170"}
            render={({ subscribe, status, message }) => {
              return(
              <div style={{paddingLeft: 40, marginTop: 25}}>
                <MailchimpForm onSubmitted={formData => subscribe(formData)} sendingState={status} errorMsg = {message} />
                <div>
                {status === "sending" && <div style={{ color: "#4dbd74" }}>sending...</div>}
                {status === "error" && <div style={{ color: "red" }} dangerouslySetInnerHTML={{__html: message}}/>}
                {status === "success" &&<div style={{color: '#4dbd74'}}>
                Subscribed !
                </div>}
                </div>
              </div>
            )}}
          />  
          </div>
          </Modal>
      </React.Fragment>
    );
  }
}

export default MailchimpModal;





// WEBPACK FOOTER //
// ./client/src/components/mailchimpModal.js